import React, { useState, useEffect } from 'react';
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { EyeIcon } from '@heroicons/react/16/solid';
import { instance2 } from '../../utils/axiosInstance'
import { ReactComponent as PlusIcon } from "../../img/plusicon.svg";
import { useNavigate } from 'react-router-dom'
import { ReactComponent as ArrowUpIcon } from "../../img/307-arrow-up.svg";

export default function PriceUploadTable() {
  const storedLocationId = localStorage.getItem("locationId");
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await instance2.get(`price_upload_header/${storedLocationId}`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  // Filter
  const filteredData = data.filter((item) => {
    const query = searchQuery.toLowerCase();

    const formattedStartDate = item.startdate
      ? new Date(item.startdate).toLocaleDateString("id-ID", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      }).toLowerCase()
      : "";

    const formattedLastUpdated = item.last_updated
      ? new Date(item.last_updated).toLocaleDateString("id-ID", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      }).toLowerCase()
      : "";

    return (
      (item.ingredient_name || "").toLowerCase().includes(query) ||
      (item.supplier_name || "").toLowerCase().includes(query) ||
      formattedStartDate.includes(query) ||
      formattedLastUpdated.includes(query) ||
      String(item.price)?.includes(query) ||
      String(item.price_diff)?.includes(query) ||
      String(item.date_diff)?.includes(query)
    );
  });

  // Sort
  const sortedFilteredData = [...filteredData].sort((a, b) => {
    const { key, direction } = sortConfig;
    if (!key) return 0;

    const aVal = a[key];
    const bVal = b[key];

    const isNumeric = !isNaN(Number(aVal)) && !isNaN(Number(bVal));
    if (isNumeric) {
      return direction === "asc"
        ? Number(aVal) - Number(bVal)
        : Number(bVal) - Number(aVal);
    }

    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    return 0;
  });

  // Paginate
  const totalPages = Math.ceil(sortedFilteredData.length / itemsPerPage);
  const paginatedData = sortedFilteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  let pageNumbers = [];
  const maxVisiblePages = 5;
  if (totalPages <= maxVisiblePages) {
    pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (currentPage <= 3) {
      pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
    } else if (currentPage >= totalPages - 2) {
      pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
    }
  }

  return (
    <div className="p-4">
      <div className="flex flex-col items-start md:flex-row justify-between">
        <h2 className="text-xl sm:text-2xl font-medium text-black my-2">Daftar Harga</h2>
        <button
          onClick={() => navigate('/uploadharga')}
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-base"
        >
          Upload CSV
        </button>
      </div>
      

  {data.length === 0 ? (
    <div className="flex items-center justify-center h-40">
      <p className="text-gray-500 text-sm sm:text-base">Belum ada data</p>
    </div>
  ) : (
    <>
{/* Search Bar */}
<div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2">
<div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
  <MagnificationLogo className="w-6 h-6" />
  <VerticalLine className="mx-1" />
  <input
    type="text"
    placeholder="Telusuri data berdasarkan nama, harga, atau tanggal"
    className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm text-xxs md:text-xxs lg:text-base"
    style={{
      width: `${"Telusuri data berdasarkan nama, harga, atau tanggal".length}ch`,
    }}
    value={searchQuery} // Controlled input
    onChange={(e) => setSearchQuery(e.target.value)} // Update search query
  />
</div>

{/* Filter Icon */}
{/* <div className="text-gray-400">
  <FilterLogo />
</div> */}
</div>
      {/* Table */}
      <table className="table-fixed w-full border-collapse text-left">
        <thead>
          <tr className="bg-white">
            <th className="w-[50px] border-b px-4 py-2 cursor-pointer rounded-tl-[15px]" onClick={() => handleSort('id')}>
              No.<span className="float-right">{getSortArrow('id')}</span>
            </th>
            <th className="border-b px-4 py-2 cursor-pointer text-left" onClick={() => handleSort('ingredient_name')}>
              Nama Bahan Baku <span className="float-right">{getSortArrow('ingredient_name')}</span>
            </th>
            <th className="border-b px-4 py-2 cursor-pointer text-right" onClick={() => handleSort('price')}>
              Harga Terbaru <span className="float-right">{getSortArrow('price')}</span>
            </th>
            <th className="border-b px-4 py-2 cursor-pointer text-right" onClick={() => handleSort('price_diff')}>
              Perbedaan Harga <span className="float-right">{getSortArrow('price_diff')}</span>
            </th>
            <th className="border-b px-4 py-2 cursor-pointer text-center" onClick={() => handleSort('day_diff')}>
              Jumlah Hari Sejak Update Terakhir <span className="float-right">{getSortArrow('day_diff')}</span>
            </th>
            <th className="border-b px-4 py-2 cursor-pointer text-center" onClick={() => handleSort('last_updated')}>
              Tanggal Update Harga <span className="float-right">{getSortArrow('last_updated')}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {[...paginatedData, ...Array.from({ length: itemsPerPage - paginatedData.length }).map(() => ({ empty: true }))].map((item, index) => (
            <tr
              key={index}
              className={`hover:bg-gray-200 ${index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"} ${item.empty ? "invisible border-transparent" : "border-b border-gray-300"}`}
            >
              <td className="px-4 py-2 text-center">{index + 1 + (currentPage - 1) * itemsPerPage}</td>
              <td className="px-4 py-2 text-left">{item.ingredient_name ?? '-'}</td>
              <td className="px-4 py-2 text-right">{Math.abs(Number(item.price)).toLocaleString("id-ID")}</td>
              <td className="px-4 py-2 text-right flex items-center justify-end gap-1">
                {Number(item.price_diff) === 0 ? (
                  <span className="text-gray-500">~</span>
                ) : (
                  <>
                    <span>{Math.abs(Number(item.price_diff)).toLocaleString("id-ID")}</span>
                    <ArrowUpIcon
                      className={`w-4 h-4 ${Number(item.price_diff) > 0 ? "text-red-500" : "rotate-180 text-green-500"} transition-transform duration-300`}
                    />
                  </>
                )}
              </td>
              <td className="px-4 py-2 text-center">{item.date_diff ?? 0}</td>
              <td className="px-4 py-2 text-center">
                {new Date(item.last_updated).toLocaleDateString("id-ID", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
        <button
          className={`px-2 py-2 rounded ${currentPage === 1 ? "text-gray-400 cursor-not-allowed" : "text-gray-500 hover:text-black"}`}
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
        </button>
        <div className="flex items-center">
          {pageNumbers.map((page, index) => (
            <span
              key={index}
              onClick={() => typeof page === "number" && setCurrentPage(page)}
              className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
                currentPage === page ? "text-black font-semibold" : "text-gray-700"
              } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
            >
              {page}
            </span>
          ))}
        </div>
        <button
          className={`px-2 py-2 rounded ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed" : "text-gray-500 hover:text-black"}`}
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          <span className="font-bold text-lg sm:text-2xl">{">"}</span>
        </button>
      </div>
    </>
      )}
    </div>
  );
}
